import { usePathname } from 'next/navigation';

import { getSupportedLocations } from '@/modules/location/helpers';

export function useIsHomepage() {
  const pathname = usePathname();
  const supportedLocations = getSupportedLocations(
    process.env.NEXT_PUBLIC_SUPPORTED_LOCATIONS || ''
  );

  return (
    ['/', '/start-to-sell/'].includes(pathname) ||
    supportedLocations.some((locale) =>
      [`/${locale}/`, `/${locale}/start-to-sell/`].includes(pathname)
    )
  );
}
